import { Box } from '@mui/material';
import { BarElement, CategoryScale, ChartDataset, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export type DashHBarDataset = ChartDataset<"bar", number[]>[];

interface IProps {
    datasets: DashHBarDataset;
    backgroundColor: (string | undefined)[];
    isPercentage?: boolean;
    labels: string[];
    height?: number | string;
    width?: number | string;
    enableTooltip?: boolean;
    onClickDrillDown?: (index: number) => void;
}

export const DashHBarCustom: React.FC<IProps> = ({
    height = 300,
    width = "100%",
    isPercentage = false,
    enableTooltip = true,
    datasets,
    labels,
    backgroundColor,
    onClickDrillDown
}) => {
    return (
        <Box>
            <Bar
                height={height}
                width={width}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    onClick: (e, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            if (onClickDrillDown) onClickDrillDown(index);
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        datalabels: {
                            display: false,
                        },
                        tooltip: {
                            enabled: enableTooltip,
                            callbacks: {
                                label: (context) => {
                                    return context.formattedValue + (isPercentage ? "%" : "");
                                }
                            }
                        },
                    },
                    scales: {
                        x: {
                            min: 0,
                            max: isPercentage ? 100 : undefined,
                            ticks: {
                                callback: (value, index, tick) => {
                                    if (Number.isInteger(value))
                                        return value + (isPercentage ? "%" : "");
                                }
                            }
                        },
                    }
                }}
                data={{
                    datasets: datasets.map(p => ({
                        ...p,
                        backgroundColor: backgroundColor,
                        borderWidth: 2,
                        barThickness: 20,
                        borderColor: backgroundColor
                    })),
                    labels
                }}
            />
        </Box>
    );
};
